import React from 'react';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';

import JournalCategory from '../../../../components/templates/journal/journalCategory';
import JournalCategorySchema from '../../../../components/molecules/journal/seo/category/JournalCategorySchema';
import { formatUrl } from '../../../../components/molecules/journal/utils';

const JournalSectionTastic = ({ data, tastic, context, isServerSideRendering }) => {
  const isSSR = typeof isServerSideRendering === 'boolean' && isServerSideRendering;
  const content = data?.blogSectionData;
  const category = content?.category || null;
  const categories = content?.topCategories ?? [];
  const articlesCollection = category?.articlesCollection ?? {};
  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const metaTitle = category?.metaTitle ?? '';
  const metaDescription = category?.metaDescription ?? '';
  const metaKeywords = category?.metaKeywords ?? '';
  const pageTitle = category?.title;
  const description = category?.shortDescription;

  const metaData = {
    title: metaTitle || pageTitle,
    description: metaDescription || description,
    keywords: metaKeywords || '',
  };

  return (
    <>
      <JournalCategory
        isSSR={isSSR}
        sectionName
        categories={categories}
        title={pageTitle}
        description={description}
        backgroundColor={category?.backgroundColor}
        pageTitle={data?.title}
        activeSlug={category?.slug}
        articles={articlesCollection?.items}
        total={articlesCollection?.total}
        teaser={category?.teaser}
        banner={category?.topBanner}
        articleSection={[
          {
            title: category?.title,
            url: category?.url,
          },
        ]}
        paginationState={{
          limit: articlesCollection?.limit,
          skip: articlesCollection?.skip,
          total: articlesCollection?.total,
        }}
      />
      <JournalCategorySchema
        title={metaData?.title}
        description={metaData?.description}
        keywords={metaData?.keywords}
        url={formatUrl(category?.url)}
        image={articlesCollection?.items?.[0]?.thumbnail?.desktop?.url}
        articles={articlesCollection?.items}
      />
    </>
  );
};

export default tastify({
  translate: true,
  connect: {
    tastic: true,
    isServerSideRendering: true,
    context: true,
  },
})(JournalSectionTastic);
